import { render, staticRenderFns } from "./productionToughYieldChartWidget.vue?vue&type=template&id=2a010f98&"
import script from "./productionToughYieldChartWidget.vue?vue&type=script&lang=js&"
export * from "./productionToughYieldChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports